export const MerchantSelectionNotFoundViewStyles = {
  title: 'text-28px text-blue700 mt-6 font-bold',
  description: 'text-18px text-blue700 mt-6 w-3/4 text-center',
  merchantsLocatorTitle: 'text-20px text-blue300 text-center mb-2'
}
